import React from "react";
import { string, oneOfType, number, objectOf, shape, oneOf } from "prop-types";
import cx from "classnames";
import { LOCAL_EN, LOCAL_FR } from "../../../const/const";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../sharedComponents/Card";
import { FormattedMoney } from "../../FormattedMoney";
import * as styles from "./FlightCard.module.scss";

const FlightCard = ({ className, style, link, header, days, price, local, labels }) => (
	<Card className={cx(styles.flightCard, className)} style={style}>
		<Card.Header className={cx(styles.heading)}>{header}</Card.Header>
		<Card.BodyContainer className={cx(styles.contentContainer)}>
			<div>
				{labels.from && (
					<Card.Subheader className={cx(styles.subheading)}>From {labels.from}</Card.Subheader>
				)}
				<div>
					{labels.dayOfWeek && <p>{labels.dayOfWeek}</p>}
					{labels.departureDate && <p>{labels.departureDate}</p>}
					{days && <p>{days}</p>}
				</div>
			</div>
			<div className={cx(styles.price)}>
				<div className={cx(styles.amount)}>
					<FormattedMoney number={price} local={local} />
				</div>
				<span className={cx(styles.priceTaxes)}>{labels.taxAndFee}</span>
			</div>
		</Card.BodyContainer>
		<Card.Link to={link.to} target={link.target} withoutIcon className={cx(styles.flightCardLink)}>
			<span className="sr-only">{header}</span>
		</Card.Link>
	</Card>
);

FlightCard.propTypes = {
	header: string.isRequired,
	link: shape({
		to: string.isRequired,
		target: string,
		icon: string,
		text: string,
	}).isRequired,
	className: string,
	style: objectOf(oneOfType([string, number])),

	days: string.isRequired,
	price: number.isRequired,
	local: oneOf([LOCAL_FR, LOCAL_EN]),
	labels: shape({
		from: string,
		daysOfWeek: string,
		departureDate: string,
		taxAndFee: string,
	}).isRequired,
};

FlightCard.defaultProps = {
	className: "",
	style: {},
	local: LOCAL_EN,
};

export default FlightCard;
export { FlightCard };
